import React, { useState, useEffect } from 'react';
import { Route, Switch, useHistory } from 'react-router';
import { ContentContainer } from '../../components/ContentContainer';
import { GenericToolbar } from '../../components/GenericToolbar/GenericToolbar';
import { pushAppRoute } from '../../data/domain/route-manager';
import { AppRoute, AppRoutes } from '../../routes';
//import { PxChildDeviceProfileData } from '../../components/DeviceProfile/PxChildProfileData';
//import { useDeviceDetails } from '../../data/DataProviders/DeviceDetailsProvider';
import { useStarfishChildDeviceDetails } from '../../data/DataProviders/StarfishChildDeviceDetailsProvider';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import { isRecordFound, useSelectedOrganizationData } from '../../hooks/data-hooks';
import { DataIndicators } from '../../components/DataIndicators';
import { StarfishChildDeviceData } from '../../types/device';
import { isDataLoaded } from '../../types';
import { StarFishChildDeviceProfileData } from '../../components/DeviceProfile/StarfishChildDeviceProfileData';
import { EditStarfishChildDevice } from '../../components/DeviceProfile/EditStarfishChildDevice';
//import { useStarfishDeviceDetails, StarfishGatewayDeviceDetailsProvider } from '../../data/DataProviders/StarfishGatewayDeviceDetailsProvider';
//import { StarfishDevice } from '../../api/types';
export const StarfishChildDeviceProfile: React.FC = () => {
    const selectedOrganization = useSelectedOrganizationData();
    const history = useHistory();
    const currentAppRoute = useCurrentAppRoute();
    // const pxChildDeviceDetails = useDeviceDetails();
    const starfishDeviceDetails = useStarfishChildDeviceDetails();

    const [childDeviceData, setChildDeviceData] = useState<StarfishChildDeviceData | null>(null);
    const [headerDeviceName, setHeaderDeviceName] = useState('');
    const currentPage =
        currentAppRoute.type === 'StarfishChildDeviceProfile'
            ? 'StarfishChildDeviceProfile'
            : 'EditStarfishChildDevice';

    const updateChildDeviceData = (modifiedData: StarfishChildDeviceData): void => {
        if (isDataLoaded(starfishDeviceDetails)) {
            const data = { ...starfishDeviceDetails.value };
            data.name = modifiedData.name;
            data.deviceIP = modifiedData.deviceIP;
            data.serial = modifiedData.serial;
            data.communicationType = modifiedData.communicationType;
            data.mac = modifiedData.mac;
            data.deviceAddress = modifiedData.deviceAddress;
            data.baudRate = modifiedData.baudRate;
            data.stopBits = modifiedData.stopBits;
            data.dataBits = modifiedData.dataBits;
            data.parity = modifiedData.parity;
            data.port = modifiedData.port;
            data.comPort = modifiedData.comPort;
            data.scanRate = modifiedData.scanRate;
            data.isDisarm = modifiedData.isDisarm;
            data.isActive = modifiedData.isActive;
            setChildDeviceData(data);
        }
    };

    useEffect(() => {
        if (isDataLoaded(starfishDeviceDetails)) {
            // console.log('starf',starfishDeviceDetails);
            setChildDeviceData(starfishDeviceDetails.value);
            setHeaderDeviceName(starfishDeviceDetails.value.name);
        }
    }, [starfishDeviceDetails]);

    const backRoute = (
        orgId: string,
        locationId: string,
        siteId: string,
        deviceId: string,
        childDeviceId: string
    ): AppRoute =>
        currentPage === 'StarfishChildDeviceProfile'
            ? {
                  type: 'StarfishDeviceProfile',
                  orgId: orgId,
                  locationId: locationId,
                  siteId: siteId,
                  deviceId: deviceId,
              }
            : {
                  type: 'StarfishChildDeviceProfile',
                  deviceId: deviceId,
                  locationId: locationId,
                  orgId: orgId,
                  siteId: siteId,
                  childDeviceId: childDeviceId,
              };
    //console.log('hiii',starfishDeviceDetails);
    return (
        <>
            {isRecordFound(selectedOrganization) &&
                'locationId' in currentAppRoute &&
                'deviceId' in currentAppRoute &&
                'siteId' in currentAppRoute &&
                'childDeviceId' in currentAppRoute && (
                    <>
                        <GenericToolbar
                            showBackButton
                            backButtonOnClick={(): void => {
                                pushAppRoute(
                                    history,
                                    backRoute(
                                        selectedOrganization.value.id,
                                        currentAppRoute.locationId,
                                        currentAppRoute.siteId,
                                        currentAppRoute.deviceId,
                                        currentAppRoute.childDeviceId
                                    )
                                );
                            }}
                            title={
                                currentPage === 'StarfishChildDeviceProfile'
                                    ? headerDeviceName
                                    : 'Edit Starfish Child Device'
                            }
                            subtitle={
                                currentPage === 'StarfishChildDeviceProfile' ? 'Device Profile' : headerDeviceName
                            }
                        />

                        <DataIndicators
                            emptyIcon="Devices"
                            emptyMessage={'No Device Data'}
                            errorMessage={'No Device Data'}
                            data={starfishDeviceDetails}
                            isEmpty={false}
                        />
                        <ContentContainer>
                            <Switch>
                                <Route exact path={AppRoutes.StarfishChildDeviceProfile}>
                                    <StarFishChildDeviceProfileData
                                        starfishDeviceDetails={childDeviceData}
                                        backAppRoute={backRoute(
                                            selectedOrganization.value.id,
                                            currentAppRoute.locationId,
                                            currentAppRoute.siteId,
                                            currentAppRoute.deviceId,
                                            currentAppRoute.childDeviceId
                                        )}
                                    />
                                </Route>
                                <Route exact path={[AppRoutes.EditStarfishChildDevice]}>
                                    <EditStarfishChildDevice
                                        childDeviceData={childDeviceData}
                                        updateChildDeviceData={updateChildDeviceData}
                                    />
                                </Route>
                            </Switch>
                        </ContentContainer>
                    </>
                )}
        </>
    );
};
